const partners = []

export default { partners }
